'use client'

import { SmartHeader } from '@/widgets/smart-header'
import { Footer } from '@/widgets/footer'
import { BuyForm } from '@/widgets/buy-form/ui/BuyForm'

export default function BuyOOOPage() {
  return (
    <div className="relative flex min-h-screen flex-col">
      <SmartHeader />
      <main className="flex-1 pt-14">
        {/* Hero секция */}
        <section className="container pt-12 md:pt-20 pb-6 md:pb-8">
          <div className="mx-auto max-w-4xl text-center">
            <h1 className="mb-6 text-3xl md:text-5xl font-bold">Купить готовое ООО</h1>
            <p className="mb-8 text-xl text-muted-foreground">
              Готовые фирмы с историей, банковскими счетами и лицензиями. Подбор за 2-3 дня,
              оформление за 1-2 дня.
            </p>
          </div>
        </section>

        {/* Форма заявки */}
        <section className="container py-6 bg-muted/20">
          <div className="mx-auto max-w-2xl">
            <BuyForm />
          </div>
        </section>

        {/* Преимущества покупки ООО */}
        <section className="container py-6">
          <div className="mx-auto max-w-6xl">
            <h2 className="mb-6 text-2xl md:text-3xl font-bold text-center">
              Преимущества покупки готового ООО
            </h2>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="flex items-start gap-3 md:gap-4 p-4 md:p-6 rounded-lg border hover:border-orange-500 transition-colors bg-background">
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-orange-100 dark:bg-orange-900/20 flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl">⚡</span>
                </div>
                <h3 className="font-semibold mb-3">Быстрый старт</h3>
                <p className="text-sm text-muted-foreground">
                  Начните бизнес сразу после покупки. Не тратьте месяцы на регистрацию и оформление.
                </p>
              </div>

              <div className="text-center p-6 bg-muted/30 rounded-lg">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🏆</span>
                </div>
                <h3 className="font-semibold mb-3">Участие в тендерах</h3>
                <p className="text-sm text-muted-foreground">
                  ООО с историей деятельности имеют преимущество при участии в тендерах и
                  госзакупках.
                </p>
              </div>

              <div className="text-center p-6 bg-muted/30 rounded-lg">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🏦</span>
                </div>
                <h3 className="font-semibold mb-3">Готовые счета</h3>
                <p className="text-sm text-muted-foreground">
                  Банковские счета и история операций. Доверие банков уже заработано.
                </p>
              </div>

              <div className="text-center p-6 bg-muted/30 rounded-lg">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">📋</span>
                </div>
                <h3 className="font-semibold mb-3">Лицензии и допуски</h3>
                <p className="text-sm text-muted-foreground">
                  ООО с готовыми лицензиями и СРО допусками для различных видов деятельности.
                </p>
              </div>

              <div className="text-center p-6 bg-muted/30 rounded-lg">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">💼</span>
                </div>
                <h3 className="font-semibold mb-3">Деловая репутация</h3>
                <p className="text-sm text-muted-foreground">
                  Готовое ООО с положительной кредитной историей и деловой репутацией.
                </p>
              </div>

              <div className="text-center p-6 bg-muted/30 rounded-lg">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🛡️</span>
                </div>
                <h3 className="font-semibold mb-3">Анализ документов</h3>
                <p className="text-sm text-muted-foreground">
                  Анализ документов, проверка отсутствия долгов и судебных разбирательств.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Процесс покупки */}
        <section className="container py-6 bg-muted/20">
          <div className="mx-auto max-w-4xl">
            <h2 className="mb-6 text-2xl md:text-3xl font-bold text-center">
              Как купить готовое ООО
            </h2>

            <div className="space-y-8">
              <div className="flex items-start space-x-6">
                <div className="w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  1
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Заявка и консультация</h3>
                  <p className="text-muted-foreground">
                    Оставьте заявку с требованиями к ООО. Проведем бесплатную консультацию, обсудим
                    ваши потребности и бюджет.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-6">
                <div className="w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  2
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Подбор вариантов</h3>
                  <p className="text-muted-foreground">
                    В течение 2-3 дней подберем несколько подходящих ООО. Предоставим полную
                    информацию по каждому варианту.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-6">
                <div className="w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  3
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Проверка и выбор</h3>
                  <p className="text-muted-foreground">
                    Проведем комплексную проверку выбранного ООО, предоставим все документы для
                    изучения. Согласуем условия сделки.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-6">
                <div className="w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  4
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Оформление сделки</h3>
                  <p className="text-muted-foreground">
                    Оформляем покупку за 1-2 дня с полным юридическим сопровождением. Безопасная
                    передача документов и прав собственности.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="container py-12 bg-muted/20">
          <div className="mx-auto max-w-4xl">
            <h2 className="mb-12 text-2xl md:text-3xl font-bold text-center">
              Часто задаваемые вопросы
            </h2>

            <div className="space-y-6">
              <div className="bg-white rounded-lg p-6">
                <h3 className="font-semibold mb-3">Сколько времени занимает покупка ООО?</h3>
                <p className="text-muted-foreground">
                  Подбор подходящего ООО — 2-3 дня. Оформление сделки и передача документов — 1-2
                  дня. Итого весь процесс занимает 3-5 рабочих дней.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6">
                <h3 className="font-semibold mb-3">Какие документы я получу при покупке?</h3>
                <p className="text-muted-foreground">
                  Полный пакет документов: устав, учредительный договор, свидетельства о
                  регистрации, печать, банковские карточки, справки об отсутствии долгов.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6">
                <h3 className="font-semibold mb-3">Гарантируете ли вы юридическую чистоту ООО?</h3>
                <p className="text-muted-foreground">
                  Да, мы проводим полную комплексную проверку каждого ООО перед продажей.
                  Предоставляем гарантию отсутствия скрытых долгов и обязательств.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}
